import { Component, OnInit, Input } from '@angular/core';

import * as State from '@shared/state';

@Component({
    selector: 'shared-vcard-for-common',
    templateUrl: './vcard-for-common.shared.component.html',
    styleUrls: ['./vcard-for-common.shared.component.scss']
})
export class VcardForCommonComponent implements OnInit {
    @Input() public sidePaddings: boolean = false;

    @Input() public preTitle: string = '';
    @Input() public preTitleType: OLO.Components.HEADER_TYPE = '5';
    @Input() public preTitleMarginTop: OLO.Components.MARGIN_SIZE = 'none';
    @Input() public preTitleMarginBottom: OLO.Components.MARGIN_SIZE = 'xs';
    @Input() public titleType: OLO.Components.HEADER_TYPE = '3';
    @Input() public titleMarginTop: OLO.Components.MARGIN_SIZE = 'none';
    @Input() public titleMarginBottom: OLO.Components.MARGIN_SIZE = 'xs';

    @Input() public description: string;

    constructor() { }

    ngOnInit(): void { }
}
